import { combineReducers } from 'redux';

import imprimirRenach from './renach/reducer';

export default combineReducers({
	imprimirRenach,
});
